/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./css.module.css";
import { connect } from "react-redux";
import defaultFooter from "../../asset/images/digitize-things-footer.png";
import { DefaultFooterImage } from "../../helper/setFallbackImages";

const Footer = (props) => {
  var extension = undefined;
  if (props.tenantData.footer) {
    if (props.tenantData.footer.startsWith("data:image")) {
      extension = "";
    } else {
      let decoded = atob(decodeURIComponent(props.tenantData.footer));
      var lowerCase = decoded.toLowerCase();
      if (lowerCase.indexOf("png") === 1) {
        extension = "png";
      } else if (
        lowerCase.indexOf("jpg") === 1 ||
        lowerCase.indexOf("jpeg") === 1
      ) {
        extension = "jpg";
      } else if (lowerCase.indexOf("svg") === 1) {
        extension = "svg+xml";
      } else if (
        lowerCase.indexOf("tif") === 1 ||
        lowerCase.indexOf("tiff") === 1
      ) {
        extension = "tiff";
      }
    }
  }
  return (
    <React.Fragment>
      {/* <footer className={classes.footer}>
                <div style={{padding: '.5rem'}}>
                <p>© 2024 - All Rights with Ooredoo</p>
                </div>
            </footer>  */}
      {props.tenantData.footer ? (
        <footer className={classes.footer}>
          {props.tenantData.footer.trim() ? (
            <>
              {props.tenantData.footer.startsWith("data:image") ? (
                <img
                  onError={DefaultFooterImage}
                  src={`${props.tenantData.footer}`}
                  alt={props.tenantData.title}
                />
              ) : (
                <img
                  onError={DefaultFooterImage}
                  src={`data:image/${extension};base64,${props.tenantData.footer}`}
                  alt={props.tenantData.title}
                />
              )}
            </>
          ) : (
            ""
          )}
        </footer>
      ) : (
        <footer className={classes.footer}>
          <img
            onError={DefaultFooterImage}
            src={""}
            alt={props.tenantData.title}
          />
        </footer>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
  };
};

export default connect(mapStateToProps)(Footer);
